module.exports = __webpack_public_path__ + "img/home-reservation.46d295ae.svg";